"use strict";
// --- Supported languages (in the app e.g. selectable for the user) ---
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedLanguageOptions = exports.DEFAULT_LOCALE = exports.LANGUAGE_LOCALES = exports.LOCALE_OVERRIDES = exports.COUNTRIES = exports.LANGUAGES = exports.SUPPORTED_LOCALES = exports.SUPPORTED_LANGUAGES = void 0;
exports.getSupportedLocales = getSupportedLocales;
exports.mapLocaleToFlagEmoji = mapLocaleToFlagEmoji;
exports.getLocaleLabel = getLocaleLabel;
exports.turnLanguageIntoLocale = turnLanguageIntoLocale;
exports.mapBrandLanguageToLocale = mapBrandLanguageToLocale;
const run_1 = require("../run");
// make sure that also the locale or language has a emoji mapping
exports.SUPPORTED_LANGUAGES = [
    {
        locale: 'en-US',
        example_phrase: (name) => 'Hi! My name is ' + name + '. Welcome to Superscale! Looking forward to creating content with you!',
        preview_phrase: 'Using this voice, you can create characters that talk about your brand or product.',
    },
    {
        locale: 'en-GB',
        example_phrase: (name) => 'Hi! My name is ' + name + '. Welcome to Superscale! Looking forward to creating content with you!',
        preview_phrase: 'Using this voice, you can create characters that talk about your brand or product.',
    },
    {
        locale: 'de-DE',
        example_phrase: (name) => 'Hallo! Mein Name ist ' +
            name +
            '. Willkommen bei Superscale! Ich freue mich darauf, mit dir Content zu erstellen!',
        preview_phrase: 'Mit dieser Stimme kannst du Charaktere über deine Marke oder Produkt sprechen lassen.',
    },
    {
        locale: 'es-ES',
        example_phrase: (name) => '¡Hola! Me llamo ' + name + '. ¡Bienvenido a Superscale! ¡Estoy deseando crear contenido contigo!',
        preview_phrase: 'Con esta voz, puedes crear personajes que hablen sobre tu marca o producto.',
    },
    {
        locale: 'nl-NL',
        example_phrase: (name) => 'Hallo! Mijn naam is ' + name + '. Welkom bij Superscale! Ik kijk ernaar uit om samen content te maken!',
        preview_phrase: 'Met deze stem kun je personages maken die over je merk of product praten.',
    },
    {
        locale: 'fr-FR',
        example_phrase: (name) => "Bonjour! Je m'appelle " +
            name +
            '. Bienvenue sur Superscale! Je suis impatient de créer du contenu avec vous!',
        preview_phrase: 'Avec cette voix, vous pouvez créer des personnages qui parlent de votre marque ou produit.',
    },
    {
        locale: 'it-IT',
        example_phrase: (name) => 'Ciao! Mi chiamo ' + name + ". Benvenuto su Superscale! Non vedo l'ora di creare contenuti con te!",
        preview_phrase: 'Con questa voce puoi creare personaggi che parlano del tuo brand o prodotto.',
    },
    {
        locale: 'sv-SE',
        example_phrase: (name) => 'Hej! Jag heter ' + name + '. Välkommen till Superscale! Jag är sugen på att skapa innehåll med dig!',
        preview_phrase: 'Med den här rösten kan du skapa karaktärer som pratar om ditt varumärke eller din produkt.',
    },
    {
        locale: 'fi-FI',
        example_phrase: (name) => 'Hei! Nimeni on ' + name + '. Tervetuloa Superscaleen! Odotan innolla sisällön luomista kanssasi!',
        preview_phrase: 'Tällä äänellä voit luoda hahmoja, jotka puhuvat brändistäsi tai tuotteestasi.',
    },
    {
        locale: 'ro-RO',
        example_phrase: (name) => 'Salut! Mă numesc ' + name + '. Bine ai venit la Superscale! Aș dori să creez conținut cu tine!',
        preview_phrase: 'Cu această voce poți crea personaje care vorbesc despre brandul sau produsul tău.',
    },
    {
        locale: 'bg-BG',
        example_phrase: (name) => 'Здравей! Аз съм ' + name + '. Добре дошли в Superscale! Желая да създам съдържание с теб!',
        preview_phrase: 'С този глас можете да създавате персонажи, които говорят за вашия бранд или продукт.',
    },
    {
        locale: 'pt-PT',
        example_phrase: (name) => 'Olá! Meu nome é ' + name + '. Bem-vindo ao Superscale! Estou ansioso para criar conteúdo com você!',
        preview_phrase: 'Com esta voz, pode criar personagens que falam sobre a sua marca ou produto.',
    },
    {
        locale: 'el-GR',
        example_phrase: (name) => 'Γεια σας! Με λένε ' +
            name +
            '. Καλώς ήλθες στο Superscale! Είμαι περίπλουστος να δημιουργήσω περιεχόμενο μαζί σας!',
        preview_phrase: 'Με αυτή τη φωνή μπορείτε να δημιουργήσετε χαρακτήρες που μιλούν για το brand ή το προϊόν σας.',
    },
    {
        locale: 'pl-PL',
        example_phrase: (name) => 'Cześć! Nazywam się ' + name + '. Witaj w Superscale! Chcę stworzyć z tobą treść!',
        preview_phrase: 'Dzięki temu głosowi możesz tworzyć postacie, które opowiadają o Twojej marce lub produkcie.',
    },
    {
        locale: 'cs-CZ',
        example_phrase: (name) => 'Ahoj! Jmenuji se ' + name + '. Vítej v Superscale! Těším se na tvorbu obsahu s tebou!',
        preview_phrase: 'S tímto hlasem můžete vytvářet postavy, které mluví o vaší značce nebo produktu.',
    },
    {
        locale: 'sk-SK',
        example_phrase: (name) => 'Ahoj! Volám sa ' + name + '. Vitaj v Superscale! Teším sa na tvorbu obsahu s tebou!',
        preview_phrase: 'S týmto hlasom môžete vytvárať postavy, ktoré hovoria o vašej značke alebo produkte.',
    },
    {
        locale: 'hu-HU',
        example_phrase: (name) => 'Szia! A nevem ' + name + '. Üdv a Superscale-nél! Alig várom, hogy együtt tartalmat készítsünk!',
        preview_phrase: 'Ezzel a hanggal olyan karaktereket hozhatsz létre, akik a márkádról vagy termékedről beszélnek.',
    },
    {
        locale: 'uk-UA',
        example_phrase: (name) => 'Привіт! Мене звати ' +
            name +
            '. Ласкаво просимо до Superscale! З нетерпінням чекаю спільного створення контенту!',
        preview_phrase: 'За допомогою цього голосу ви можете створювати персонажів, які розповідають про ваш бренд або продукт.',
    },
    {
        locale: 'ru-RU',
        example_phrase: (name) => 'Привет! Меня зовут ' +
            name +
            '. Добро пожаловать в Superscale! С нетерпением жду совместного создания контента!',
        preview_phrase: 'С помощью этого голоса вы можете создавать персонажей, которые рассказывают о вашем бренде или продукте.',
    },
    {
        locale: 'da-DK',
        example_phrase: (name) => 'Hej! Jeg hedder ' + name + '. Velkommen til Superscale! Jeg glæder mig til at skabe indhold sammen!',
        preview_phrase: 'Med denne stemme kan du skabe karakterer, der taler om dit brand eller produkt.',
    },
    {
        locale: 'no-NO',
        example_phrase: (name) => 'Hei! Jeg heter ' + name + '. Velkommen til Superscale! Gleder meg til å lage innhold sammen!',
        preview_phrase: 'Med denne stemmen kan du lage karakterer som snakker om merkevaren eller produktet ditt.',
    },
    {
        locale: 'sl-SI',
        example_phrase: (name) => 'Živjo! Ime mi je ' + name + '. Dobrodošli na Superscale! Veselim se ustvarjanja vsebine skupaj!',
        preview_phrase: 'S tem glasom lahko ustvarite like, ki govorijo o vaši blagovni znamki ali izdelku.',
    },
    {
        locale: 'hr-HR',
        example_phrase: (name) => 'Bok! Zovem se ' + name + '. Dobrodošli u Superscale! Veselim se zajedničkom stvaranju sadržaja!',
        preview_phrase: 'S ovim glasom možete stvarati likove koji govore o vašem brendu ili proizvodu.',
    },
    {
        locale: 'ga-IE',
        example_phrase: (name) => 'Dia dhuit! Is é ' +
            name +
            ' an t-ainm atá orm. Fáilte go Superscale! Táim ag súil le hábhar a chruthú leat!',
        preview_phrase: 'Leis an nguth seo, is féidir leat carachtair a chruthú a labhraíonn faoi do bhranda nó do tháirge.',
    },
    {
        locale: 'tr-TR',
        example_phrase: (name) => 'Merhaba! Ben ' + name + '. Superscale’e hoşgeldin! Birlikte içerik oluşturmayı çok istiyorum!',
        preview_phrase: 'Bu sesle, markanız veya ürününüz hakkında konuşan karakterler oluşturabilirsiniz.',
    },
    {
        locale: 'pt-BR',
        example_phrase: (name) => 'Olá! Meu nome é ' + name + '. Bem-vindo ao Superscale! Mal posso esperar para criar conteúdo com você!',
        preview_phrase: 'Com essa voz, você pode criar personagens que falam sobre a sua marca ou produto.',
    },
    {
        locale: 'es-AR',
        example_phrase: (name) => '¡Hola! Me llamo ' + name + '. ¡Bienvenido a Superscale! ¡No puedo esperar para crear contenido contigo!',
        preview_phrase: 'Con esta voz podés crear personajes que hablen sobre tu marca o producto.',
    },
    {
        locale: 'es-MX',
        example_phrase: (name) => '¡Hola! Me llamo ' + name + '. ¡Bienvenido a Superscale! ¡Estoy deseando crear contenido contigo!',
        preview_phrase: 'Con esta voz puedes crear personajes que hablen sobre tu marca o producto.',
    },
    {
        locale: 'es-CO',
        example_phrase: (name) => '¡Hola! Me llamo ' + name + '. ¡Bienvenido a Superscale! ¡Estoy deseando crear contenido contigo!',
        preview_phrase: 'Con esta voz puedes crear personajes que hablen sobre tu marca o producto.',
    },
    {
        locale: 'fil-PH',
        example_phrase: (name) => 'Kumusta! Ako si ' +
            name +
            '. Maligayang pagdating sa Superscale! Sabik na akong gumawa ng content kasama mo!',
        preview_phrase: 'Gamit ang boses na ito, maaari kang lumikha ng mga karakter na magsasalita tungkol sa iyong brand o produkto.',
    },
];
function getSupportedLocales() {
    const locales = exports.SUPPORTED_LANGUAGES.map((language) => language.locale);
    return locales;
}
exports.SUPPORTED_LOCALES = getSupportedLocales();
// --- All languages (used for backend processing e.g. ElevenLabs) ---
exports.LANGUAGES = {
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    de: 'German',
    zh: 'Chinese',
    ja: 'Japanese',
    ko: 'Korean',
    ru: 'Russian',
    pt: 'Portuguese',
    it: 'Italian',
    ar: 'Arabic',
    hi: 'Hindi',
    bn: 'Bengali',
    pa: 'Punjabi',
    jv: 'Javanese',
    ms: 'Malay',
    id: 'Indonesian',
    vi: 'Vietnamese',
    tr: 'Turkish',
    fa: 'Persian',
    ur: 'Urdu',
    ta: 'Tamil',
    te: 'Telugu',
    mr: 'Marathi',
    nl: 'Dutch',
    sv: 'Swedish',
    no: 'Norwegian',
    da: 'Danish',
    fi: 'Finnish',
    pl: 'Polish',
    uk: 'Ukrainian',
    cs: 'Czech',
    sk: 'Slovak',
    hu: 'Hungarian',
    ro: 'Romanian',
    bg: 'Bulgarian',
    el: 'Greek',
    he: 'Hebrew',
    th: 'Thai',
    km: 'Khmer',
    my: 'Burmese',
    ml: 'Malayalam',
    gu: 'Gujarati',
    kn: 'Kannada',
    am: 'Amharic',
    sw: 'Swahili',
    ha: 'Hausa',
    ig: 'Igbo',
    yo: 'Yoruba',
    zu: 'Zulu',
    hr: 'Croatian',
    is: 'Icelandic',
    sl: 'Slovenian',
    sr: 'Serbian',
    sq: 'Albanian',
    be: 'Belarusian',
    ga: 'Irish',
    fil: 'Filipino',
};
exports.COUNTRIES = {
    US: 'United States',
    GB: 'United Kingdom',
    DE: 'Germany',
    AT: 'Austria',
    CH: 'Switzerland',
    FR: 'France',
    CA: 'Canada',
    ES: 'Spain',
    MX: 'Mexico',
    AR: 'Argentina',
    CO: 'Colombia',
    CL: 'Chile',
    LT: 'Lithuania',
    LV: 'Latvia',
    EE: 'Estonia',
    SI: 'Slovenia',
    BY: 'Belarus',
    BA: 'Bosnia and Herzegovina',
    ME: 'Montenegro',
    RS: 'Serbia',
    MK: 'North Macedonia',
    AL: 'Albania',
    CN: 'China',
    TW: 'Taiwan',
    JP: 'Japan',
    KR: 'South Korea',
    RU: 'Russia',
    BR: 'Brazil',
    PT: 'Portugal',
    IT: 'Italy',
    AE: 'United Arab Emirates',
    SA: 'Saudi Arabia',
    EG: 'Egypt',
    IN: 'India',
    BD: 'Bangladesh',
    PK: 'Pakistan',
    ID: 'Indonesia',
    MY: 'Malaysia',
    VN: 'Vietnam',
    TR: 'Turkey',
    IR: 'Iran',
    NL: 'Netherlands',
    BE: 'Belgium',
    SE: 'Sweden',
    NO: 'Norway',
    DK: 'Denmark',
    FI: 'Finland',
    PL: 'Poland',
    UA: 'Ukraine',
    CZ: 'Czech Republic',
    SK: 'Slovakia',
    HU: 'Hungary',
    RO: 'Romania',
    BG: 'Bulgaria',
    GR: 'Greece',
    IL: 'Israel',
    TH: 'Thailand',
    KH: 'Cambodia',
    MM: 'Myanmar',
    ET: 'Ethiopia',
    KE: 'Kenya',
    NG: 'Nigeria',
    ZA: 'South Africa',
    HR: 'Croatia',
    IS: 'Iceland',
    IE: 'Ireland',
};
exports.LOCALE_OVERRIDES = {
    'en-US': 'English (United States)',
    'en-GB': 'English (United Kingdom)',
    'es-ES': 'Spanish (Spain)',
    'es-MX': 'Spanish (Mexico)',
    'fr-FR': 'French (France)',
    'fr-CA': 'French (Canada)',
    'de-DE': 'German (Germany)',
    'de-AT': 'German (Austria)',
    'de-CH': 'German (Switzerland)',
    'zh-CN': 'Chinese (China)',
    'zh-TW': 'Chinese (Taiwan)',
    'cmn-CN': 'Mandarin Chinese (China)',
    'ja-JP': 'Japanese (Japan)',
    'ko-KR': 'Korean (South Korea)',
    'ru-RU': 'Russian (Russia)',
    'pt-PT': 'Portuguese (Portugal)',
    'pt-BR': 'Portuguese (Brazil)',
    'it-IT': 'Italian (Italy)',
    'ar-SA': 'Arabic (Saudi Arabia)',
    'ar-EG': 'Arabic (Egypt)',
    'hi-IN': 'Hindi (India)',
    'bn-BD': 'Bengali (Bangladesh)',
    'pa-IN': 'Punjabi (India)',
    'ur-PK': 'Urdu (Pakistan)',
    'ta-IN': 'Tamil (India)',
    'te-IN': 'Telugu (India)',
    'mr-IN': 'Marathi (India)',
    'gu-IN': 'Gujarati (India)',
    'kn-IN': 'Kannada (India)',
    'ml-IN': 'Malayalam (India)',
    'jv-ID': 'Javanese (Indonesia)',
    'ms-MY': 'Malay (Malaysia)',
    'id-ID': 'Indonesian (Indonesia)',
    'vi-VN': 'Vietnamese (Vietnam)',
    'tr-TR': 'Turkish (Turkey)',
    'fa-IR': 'Persian (Iran)',
    'nl-NL': 'Dutch (Netherlands)',
    'sv-SE': 'Swedish (Sweden)',
    'no-NO': 'Norwegian (Norway)',
    'da-DK': 'Danish (Denmark)',
    'fi-FI': 'Finnish (Finland)',
    'pl-PL': 'Polish (Poland)',
    'uk-UA': 'Ukrainian (Ukraine)',
    'cs-CZ': 'Czech (Czech Republic)',
    'sk-SK': 'Slovak (Slovakia)',
    'hu-HU': 'Hungarian (Hungary)',
    'ro-RO': 'Romanian (Romania)',
    'bg-BG': 'Bulgarian (Bulgaria)',
    'el-GR': 'Greek (Greece)',
    'he-IL': 'Hebrew (Israel)',
    'th-TH': 'Thai (Thailand)',
    'km-KH': 'Khmer (Cambodia)',
    'my-MM': 'Burmese (Myanmar)',
    'am-ET': 'Amharic (Ethiopia)',
    'sw-KE': 'Swahili (Kenya)',
    'ha-NG': 'Hausa (Nigeria)',
    'ig-NG': 'Igbo (Nigeria)',
    'yo-NG': 'Yoruba (Nigeria)',
    'zu-ZA': 'Zulu (South Africa)',
    'fil-PH': 'Filipino',
};
exports.LANGUAGE_LOCALES = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    de: 'de-DE',
    zh: 'zh-CN',
    ja: 'ja-JP',
    ko: 'ko-KR',
    ru: 'ru-RU',
    pt: 'pt-PT',
    it: 'it-IT',
    ar: 'ar-SA',
    hi: 'hi-IN',
    bn: 'bn-BD',
    pa: 'pa-IN',
    ur: 'ur-PK',
    ta: 'ta-IN',
    te: 'te-IN',
    mr: 'mr-IN',
    gu: 'gu-IN',
    kn: 'kn-IN',
    ml: 'ml-IN',
    jv: 'jv-ID',
    ms: 'ms-MY',
    id: 'id-ID',
    vi: 'vi-VN',
    tr: 'tr-TR',
    fa: 'fa-IR',
    nl: 'nl-NL',
    sv: 'sv-SE',
    no: 'no-NO',
    da: 'da-DK',
    fi: 'fi-FI',
    pl: 'pl-PL',
    uk: 'uk-UA',
    cs: 'cs-CZ',
    sk: 'sk-SK',
    hu: 'hu-HU',
    ro: 'ro-RO',
    bg: 'bg-BG',
    el: 'el-GR',
    he: 'he-IL',
    th: 'th-TH',
    km: 'km-KH',
    my: 'my-MM',
    am: 'am-ET',
    sw: 'sw-KE',
    ha: 'ha-NG',
    ig: 'ig-NG',
    yo: 'yo-NG',
    zu: 'zu-ZA',
    fil: 'fil-PH',
};
function mapLocaleToFlagEmoji(locale) {
    const emoji = (0, run_1.run)(() => {
        switch (locale.toLowerCase()) {
            case 'en-us':
                return '🇺🇸';
            case 'en-gb':
                return '🇬🇧';
            case 'en-au':
                return '🇦🇺';
            case 'en-ca':
                return '🇨🇦';
            case 'en-nz':
                return '🇳🇿';
            case 'en-za':
                return '🇿🇦';
            case 'en-in':
                return '🇮🇳';
            case 'en-ie':
                return '🇮🇪';
            case 'de-de':
            case 'de-at':
            case 'de-ch':
                return '🇩🇪';
            case 'nl-nl':
                return '🇳🇱';
            case 'es-es':
                return '🇪🇸';
            case 'fr-fr':
                return '🇫🇷';
            case 'it-it':
                return '🇮🇹';
            case 'pt-pt':
                return '🇵🇹';
            case 'fi-fi':
                return '🇫🇮';
            case 'ru-ru':
                return '🇷🇺';
            case 'tr-tr':
                return '🇹🇷';
            case 'uk-ua':
                return '🇺🇦';
            case 'pl-pl':
                return '🇵🇱';
            case 'ro-ro':
                return '🇷🇴';
            case 'bg-bg':
                return '🇧🇬';
            case 'el-gr':
                return '🇬🇷';
            case 'hr-hr':
                return '🇭🇷';
            case 'ko-kr':
                return '🇰🇷';
            case 'cmn-cn':
            case 'zh-cn':
                return '🇨🇳';
            case 'zh-tw':
                return '🇹🇼';
            case 'ja-jp':
                return '🇯🇵';
            default: {
                const countryCode = locale.split('-')[1];
                if (!countryCode)
                    return null;
                switch (countryCode.toLowerCase()) {
                    case 'pl':
                        return '🇵🇱';
                    case 'de':
                        return '🇩🇪';
                    case 'fr':
                        return '🇫🇷';
                    case 'it':
                        return '🇮🇹';
                    case 'es':
                        return '🇪🇸';
                    case 'nl':
                        return '🇳🇱';
                    case 'pt':
                        return '🇵🇹';
                    case 'ru':
                        return '🇷🇺';
                    case 'tr':
                        return '🇹🇷';
                    case 'uk':
                        return '🇺🇦';
                    case 'us':
                        return '🇺🇸';
                    case 'gb':
                        return '🇬🇧';
                    case 'au':
                        return '🇦🇺';
                    case 'ca':
                        return '🇨🇦';
                    case 'nz':
                        return '🇳🇿';
                    case 'za':
                        return '🇿🇦';
                    case 'in':
                        return '🇮🇳';
                    case 'ie':
                        return '🇮🇪';
                    case 'ch':
                        return '🇨🇭';
                    case 'at':
                        return '🇦🇹';
                    case 'li':
                        return '🇱🇮';
                    case 'lu':
                        return '🇱🇺';
                    case 'se':
                        return '🇸🇪';
                    case 'no':
                        return '🇳🇴';
                    case 'dk':
                        return '🇩🇰';
                    case 'fi':
                        return '🇫🇮';
                    case 'is':
                        return '🇮🇸';
                    case 'lt':
                        return '🇱🇹';
                    case 'lv':
                        return '🇱🇻';
                    case 'ee':
                        return '🇪🇪';
                    case 'cz':
                        return '🇨🇿';
                    case 'sk':
                        return '🇸🇰';
                    case 'hr':
                        return '🇭🇷';
                    case 'si':
                        return '🇸🇮';
                    case 'ba':
                        return '🇧🇦';
                    case 'me':
                        return '🇲🇪';
                    case 'rs':
                        return '🇷🇸';
                    case 'al':
                        return '🇦🇱';
                    case 'by':
                        return '🇧🇾';
                    case 'hu':
                        return '🇭🇺';
                    case 'br':
                        return '🇧🇷';
                    case 'mx':
                        return '🇲🇽';
                    case 'ar':
                        return '🇦🇷';
                    case 'co':
                        return '🇨🇴';
                    case 'cl':
                        return '🇨🇱';
                    case 'gr':
                        return '🇬🇷';
                    case 'bg':
                        return '🇧🇬';
                    case 'ro':
                        return '🇷🇴';
                    case 'mk':
                        return '🇲🇰';
                    case 'ph':
                        return '🇵🇭';
                    case 'kr':
                        return '🇰🇷';
                    case 'cn':
                        return '🇨🇳';
                    case 'tw':
                        return '🇹🇼';
                    case 'jp':
                        return '🇯🇵';
                    case 'sa':
                        return '🇸🇦';
                    case 'eg':
                        return '🇪🇬';
                    case 'ae':
                        return '🇦🇪';
                    case 'id':
                        return '🇮🇩';
                    case 'my':
                        return '🇲🇾';
                    case 'vn':
                        return '🇻🇳';
                    case 'th':
                        return '🇹🇭';
                    case 'kh':
                        return '🇰🇭';
                    case 'mm':
                        return '🇲🇲';
                    case 'ir':
                        return '🇮🇷';
                    case 'il':
                        return '🇮🇱';
                    case 'pk':
                        return '🇵🇰';
                    case 'bd':
                        return '🇧🇩';
                    case 'lk':
                        return '🇱🇰';
                    case 'np':
                        return '🇳🇵';
                    case 'et':
                        return '🇪🇹';
                    case 'ke':
                        return '🇰🇪';
                    case 'ng':
                        return '🇳🇬';
                    case 'gh':
                        return '🇬🇭';
                    case 'tz':
                        return '🇹🇿';
                    case 'ug':
                        return '🇺🇬';
                    case 'ma':
                        return '🇲🇦';
                    case 'tn':
                        return '🇹🇳';
                    case 'dz':
                        return '🇩🇿';
                }
            }
        }
    });
    if (!emoji) {
        console.warn(`No emoji found for locale: ${locale}`);
    }
    return emoji;
}
exports.DEFAULT_LOCALE = 'en-US';
// Get a human readable label for a locale string like in LOCALE_OVERRIDES (e.g. it-IT -> Italian (Italy))
function getLocaleLabel(locale) {
    const normalized = locale.trim().split(/[\.\@]/)[0];
    const upperLocale = normalized.replace(/([a-z]{2})([-_])([a-z]{2})/i, (_match, lang, _sep, country) => `${lang.toLowerCase()}-${country.toUpperCase()}`);
    if (exports.LOCALE_OVERRIDES[upperLocale]) {
        return exports.LOCALE_OVERRIDES[upperLocale];
    }
    const parts = upperLocale.split(/[-_]/);
    if (parts.length === 1) {
        return exports.LANGUAGES[parts[0]] || locale;
    }
    const lang = parts[0];
    const country = parts[1];
    const languageName = exports.LANGUAGES[lang] || lang;
    const countryName = exports.COUNTRIES[country] || country;
    return `${languageName} (${countryName})`;
}
const getSupportedLanguageOptions = () => {
    return exports.SUPPORTED_LANGUAGES.map((language) => ({
        value: language.locale,
        label: getLocaleLabel(language.locale),
    }));
};
exports.getSupportedLanguageOptions = getSupportedLanguageOptions;
// Normalize a language string to a consistent language-country format where possible. Falls back to the given language if no mapping is known.
function turnLanguageIntoLocale(language) {
    const locale = exports.LANGUAGE_LOCALES[language.toLowerCase()];
    if (locale) {
        return locale;
    }
    return language;
}
function mapBrandLanguageToLocale(brandLanguage) {
    const normalized = brandLanguage.trim().replace('_', '-');
    const exactSupportedLocale = exports.SUPPORTED_LOCALES.find((supportedLocale) => supportedLocale.toLowerCase() === normalized.toLowerCase());
    if (exactSupportedLocale)
        return exactSupportedLocale;
    const normalizedLower = normalized.toLowerCase();
    const baseLanguage = normalizedLower.split('-')[0];
    const mappedLocale = exports.LANGUAGE_LOCALES[normalizedLower] ?? exports.LANGUAGE_LOCALES[baseLanguage];
    return mappedLocale && exports.SUPPORTED_LOCALES.includes(mappedLocale) ? mappedLocale : exports.DEFAULT_LOCALE;
}
